import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: 'tenant',
    name: 'tenant.index',
    component: () => import('./views/pages/TenantIndexPage.vue'),
    meta: {
      title: 'Kies een relatie',
    },
  },
  {
    path: 'tenant/request-access',
    name: 'tenant.request-access',
    component: () => import('./views/pages/TenantRequestAccessPage.vue'),
    meta: {
      title: 'Toegang aanvragen',
    },
  },
  {
    path: 'tenant/request-access/invite',
    name: 'tenant.request-access-invite',
    component: () => import('./views/pages/TenantRequestAccessInvitePage.vue'),
    meta: {
      title: 'Toegang aanvragen',
    },
  },
];
